import { render, staticRenderFns } from "./modalsRating.vue?vue&type=template&id=60d905ce&scoped=true"
import script from "./modalsRating.vue?vue&type=script&lang=js"
export * from "./modalsRating.vue?vue&type=script&lang=js"
import style0 from "./modalsRating.vue?vue&type=style&index=0&id=60d905ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d905ce",
  null
  
)

export default component.exports